import { render, staticRenderFns } from "./CoreFooter.vue?vue&type=template&id=6655eb68&"
import script from "./CoreFooter.vue?vue&type=script&lang=js&"
export * from "./CoreFooter.vue?vue&type=script&lang=js&"
import style0 from "./CoreFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports